// extracted by mini-css-extract-plugin
module.exports = {"container":"Body_container__1jgMO"};